/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';
import { candidateIndustrySchema } from './candidate-industry-schema';
import { candidateOpportunityExperienceSchema } from './candidate-opportunity-experience-schema';
import { candidateOpportunityWarmingQuestionExperienceSchema } from './candidate-opportunity-warming-question-experience-schema';
import { candidateSchema } from './candidate-schema';
import { dataScienceSuggestedSkillSchema } from './data-science-suggested-skill-schema';
import { experiencesFocusAreaOrderPreferenceSchema } from './experiences-focus-area-order-preference-schema';
import { experiencesTaxonomySchema } from './experiences-taxonomy-schema';
import { opportunitySchema } from './opportunity-schema';
import { Industry, LocationAddressComponentType } from "../enums";

export const experienceSchema: z.AnyZodObject = z.object({
  accountId: z.string().uuid().nullish(),
  candidate: z.lazy(() => candidateSchema).nullish(),
  candidateId: z.string().uuid().nullish(),
  candidateIndustries: 
    z.array(z.lazy(() => candidateIndustrySchema))
  .nullish(),
  candidateOpportunityExperiences: 
    z.array(z.lazy(() => candidateOpportunityExperienceSchema))
  .nullish(),
  candidateOpportunityWarmingQuestionExperiences: 
    z.array(z.lazy(() => candidateOpportunityWarmingQuestionExperienceSchema))
  .nullish(),
  client: z.string().nullish(),
  clientDomain: z.string().nullish(),
  createdAt: z.string().datetime().nullish(),
  dataScienceSuggestedSkills: 
    z.array(z.lazy(() => dataScienceSuggestedSkillSchema))
  .nullish(),
  description: z.string().nullish(),
  endDate: z.string().date().nullish(),
  exceptionApprovedAt: z.string().datetime().nullish(),
  exceptionApprovedBy: z.string().uuid().nullish(),
  exceptionRequestedAt: z.string().datetime().nullish(),
  expectedDescriptionLength: z.number().int(),
  experienceTaxonomy: 
    z.array(z.lazy(() => experiencesTaxonomySchema))
  .nullish(),
  experiencesFocusAreaOrderPreferences: 
    z.array(z.lazy(() => experiencesFocusAreaOrderPreferenceSchema))
  .nullish(),
  externalOpportunityName: z.string().nullish(),
  fuzzyClient: z.string().nullish(),
  generalSkills: z.array(z.string()).nullish(),
  id: z.string().uuid(),
  industryIsOverridden: z.boolean(),
  industryValue: z.nativeEnum(Industry).nullish(),
  isConfidential: z.boolean().nullish(),
  lastUpdatedBy: z.string().uuid().nullish(),
  locationAddressComponents: 
    z.object({
      addresses: 
        z.array(
          z.object({
            long_name: z.string().nullish(),
            short_name: z.string().nullish(),
            types: 
              z.array(z.nativeEnum(LocationAddressComponentType))
            .nullish(),
          })
        )
      .nullish(),
    })
  .nullish(),
  locationName: z.string().nullish(),
  locationPlaceId: z.string().nullish(),
  noFocusAreasApplyMarkedAt: z.string().datetime().nullish(),
  normalizedClient: z.string().nullish(),
  normalizedClientDomain: z.string().nullish(),
  opportunity: z.lazy(() => opportunitySchema).nullish(),
  opportunityId: z.string().uuid().nullish(),
  startDate: z.string().date().nullish(),
  suggestAxiomEngageDismissedAt: z.string().datetime().nullish(),
  suggestMergeDismissedAt: z.string().datetime().nullish(),
  suggestedFocusAreasRetrievedAt: z.string().datetime().nullish(),
  suggestedLegalSkillsRetrievedAt: z.string().datetime().nullish(),
  updatedAt: z.string().datetime().nullish(),
});

export type Experience = z.infer<typeof experienceSchema>;
